import React, { Component, PureComponent } from 'react'
import { connect } from 'react-redux'
import { attachContact } from '../actions'
import { Map, List, fromJS } from 'immutable'
import { Dropdown } from 'semantic-ui-react'
import Api from '~/api'

let wait = fn => {
  let threshhold = 300
  let deferTimer = undefined

  return function () {
    let args = arguments
    if (deferTimer) clearTimeout(deferTimer)

    deferTimer = setTimeout(function () {
      fn.apply(this, args)
    }, threshhold)
  }
}

class ContactSearch extends Component {
  state = {
    loading: false,
    searchQuery: '',
    options: [],
  }

  // componentDidMount() {
  //   let {organization_id} = this.props
  //   this.fetchContacts(organization_id)
  // }

  // componentDidUpdate({organization_id: prevOrg}) {
  //   let { organization_id } = this.props
  //   if(prevOrg !== organization_id)
  //     this.fetchContacts(organization_id)
  // }

  handleSearch = search => {
    this.setState({ loading: true, search })
    this.setState({ search })
    this.startSearch(() => this.fetchContacts(search))
  }

  startSearch = wait(start => start())

  fetchContacts = search => {
    let { global = false, organization_id } = this.props
    this.setState({
      loading: true,
    })

    let params = {
      search,
    }

    if (!global) params.organization_id = organization_id

    Api.get('/contact', params)
      .then(({ data: { items = [] } = {} }) => {
        this.setState({
          loading: false,
          options: items.map(({ id, email }) => ({ value: id, text: email })),
        })
      })
      .catch(err => console.log(err))
  }

  attachContact = contact_id => {
    let {
      organization_id,
      order_id = false,
      interview_id = false,
      project_id = false,
      task_id = false,
      attachContact,
    } = this.props

    let data = {
      organization_id,
      contact_id,
    }

    if (order_id) data.order_id = order_id

    if (interview_id) data.interview_id = interview_id

    if (project_id) data.project_id = project_id

    if (task_id) data.task_id = task_id

    attachContact(data)

    this.setState({
      searchQuery: '',
      options: [],
    })
  }

  render() {
    let { loading, attachContactLoading, attachContactError, options = [] } = this.state
    let { contacts = List() } = this.props

    options = options.filter(({ value }) => !contacts.find(c => c.get('id') === value))

    return (
      <div className="contact-search">
        {attachContactError ? <div>{attachContactError}</div> : null}
        <Dropdown
          options={options}
          text="+ Hae yhteyshenkilö"
          noResultsMessage="Yhteyshenkilöitä ei löytynyt"
          onSearchChange={(e, { searchQuery }) => this.handleSearch(searchQuery)}
          search
          fluid
          selection
          loading={loading || attachContactLoading}
          selectOnBlur={false}
          selectOnNavigation={false}
          compact
          closeOnChange
          defaultUpward
          onChange={(e, { value } = {}) => this.attachContact(value)}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    attachContactLoading: state.attachContactsLoading,
    attachContactError: state.attachContactsError,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    attachContact: data => dispatch(attachContact(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactSearch)
